import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {OfficeSummaryModel} from '../officeSummary.model';
import {Injectable} from '@angular/core';
import {PermissionsConverter} from '../../../../common/converter/permissions.converter';

@Injectable({providedIn: 'root'})
export class OfficeSummaryConverter extends HttpModelConverter<OfficeSummaryModel> {
    constructor() {
        super();
    }
    protected createInstance(): OfficeSummaryModel {
        return new OfficeSummaryModel();
    }

    protected enrichObject(result: OfficeSummaryModel, src: OfficeSummaryModel) {
        result.permissions = new PermissionsConverter().convert(src.permissions);
    }
}
